import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/process-active.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-8adb9248")

_pushScopeId("data-v-8adb9248")
const _hoisted_1 = { class: "discount-line" }
const _hoisted_2 = { class: "discount column-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title" }, "ID#", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_6 = { style: {"display":"block","width":"100%","padding-top":"25px"} }
const _hoisted_7 = { class: "discount column-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Název", -1)
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "discount column-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Stav", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "value" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "process",
    src: _imports_0,
    alt: "Aktivní"
  }),
  /*#__PURE__*/_createTextVNode("Aktivní")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.consumerGroup.id), 1),
      _hoisted_5,
      _createVNode("button", {
        class: "button-consumers",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('show-add-consumer', { id: _ctx.consumerGroup.id, name: _ctx.consumerGroup.name })))
      }, " Přidat uživatele "),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          class: "button-consumers",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
        }, " Import CSV "),
        _createVNode("input", {
          type: "file",
          ref: "fileInput",
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
          accept: ".csv"
        }, null, 544)
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode("p", _hoisted_9, _toDisplayString(_ctx.consumerGroup.name), 1)
    ]),
    _createVNode("div", _hoisted_10, [
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _createVNode("button", {
        class: "button-consumers",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('show-consumers-list', { id: _ctx.consumerGroup.id, name: _ctx.consumerGroup.name })))
      }, "Seznam uživatelů ")
    ])
  ]))
})